import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyQualModal from "./editProfileModals/editQual/EditMyQualModal";
import jnu_logo from '../../assets/jnu_logo.png';
import xaviers_logo from '../../assets/xaviers_logo.png';
import cghs_logo from '../../assets/cghs_logo.png';
import { divisionTypes } from '../../appConstants'

const QualificationCard = ({qualification}) => {    
    // Handle Date
    var startDate =  qualification.startDate
    var endDate = qualification.endDate
    var startString = startDate.toLocaleString('default', { month: 'short' }) + " " + startDate.getFullYear()
    var endString = qualification.active ? "Present" : endDate.toLocaleString('default', { month: 'short' }) + " " + endDate.getFullYear()
    // Handle Score
    var scoreType = qualification.scoreType
    var scoreString = ""
    if ( scoreType === 'CGPA')
        scoreString = qualification.score + " / " + qualification.total
    else if ( scoreType === 'percentage')
        scoreString = qualification.score + " %"
    else if ( scoreType === 'grade')
        scoreString = "Grade " + qualification.score
    var divisionTypeSelected = divisionTypes.filter((o) => qualification.divisionType === o.value)[0]
    return (
        <>
            <div className="v-align ">
                <div className="wd-pct-20 mg-r-15 b-r-border">
                    <div >{startString + " - " + endString}</div>
                    <div>{qualification.city + " ," + qualification.country}</div>
                </div>
                <div className="wd-pct-20 mg-r-15 b-r-border" >
                    <div className="card-list-header">{qualification.degree + ", " + qualification.field}
                        {qualification.active ? <span className="active-badge-static bg-c-primary-active"></span>: null}
                    </div>
                    <div className="card-list-subheader">{qualification.institute}</div>
                </div>
                <div className="wd-pct-15 text-c-success b-r-border">
                    <div>{scoreString}</div>
                    <div>{divisionTypeSelected && divisionTypeSelected.value !== 0 ?  divisionTypeSelected.label + " Class": null}</div>
                </div>
                <div >
                    <img alt="" src={jnu_logo} style={{ height: '45px' }} className="pd-l-25 c-pointer" />
                </div>
            </div>
            <div className="card-description">
                {qualification.description}
            </div>
        </>
    )
}


function MyQualification(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);
    var { profile } = props.store
    var { qualifications } = profile
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Qualification</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                    <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    <EditMyQualModal modal={newPlanModal} toggle={toggleNewPlanModal} qualifications={qualifications} />  
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                {qualifications.map((qualification, i) => (<>
                    <QualificationCard qualification={qualification}/>
                    {i != qualifications.length - 1 ? <hr className="mg-r-0" ></hr> : null}
                </>
                ))}              
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default MyQualification